import {
  createManualThunk,
  createThunk,
  ListModel,
  model,
  view,
} from 'mst-collection';
import { castToSnapshot, types } from 'mobx-state-tree';

import { TutorialModel } from './TutorialModel';
import {
  Api,
  IRelatedTutorialsParamsRequest,
  IIdRequestParams,
  schemas,
  ITutorialsRelatedResponse,
} from '@api';
import { handleFlow, shouldRejectPagination } from '../utils';

type FetchRelatedTutorialParamsType = IRelatedTutorialsParamsRequest &
  IIdRequestParams;

export class RelatedTutorialList extends ListModel(
  types.reference(TutorialModel),
  {
    idAttribute: 'id',
    schema: schemas.TutorialListSchema,
    pageSize: 20,
  },
) {
  totalCount = 0;
  categoryName = '';
  categoryDescription = '';

  @view
  numberInList(id: number) {
    const index = this.findIndexById(id);

    if (typeof index === 'number' && index !== -1) {
      return index + 1;
    } else {
      return 1;
    }
  }

  @view
  nextItem(id: number) {
    const index = this.findIndexById(id);

    if (
      typeof index === 'number' &&
      index !== -1 &&
      this.array[index + 1]
    ) {
      return this.array[index + 1];
    } else {
      return null;
    }
  }

  @view
  previousItem(id: number) {
    const index = this.findIndexById(id);

    if (
      typeof index === 'number' &&
      index !== -1 &&
      this.array[index - 1]
    ) {
      return this.array[index - 1];
    } else {
      return null;
    }
  }

  setResponse(res: ITutorialsRelatedResponse) {
    this.categoryName = res.category.name;
    this.categoryDescription = res.category.description;
    this.totalCount = res.totalCount;
    this.set(res.videos);
  }

  fetch = createThunk(
    ({ id, extraCategoryId }: FetchRelatedTutorialParamsType) => {
      return async function fetch(this: RelatedTutorialList) {
        const res = await Api.Hub.getRelatedTutorials({
          count: this.pageSize,
          id,
          extraCategoryId,
        });

        this.setResponse(res.data);
      };
    },
  );

  fetchMore = createManualThunk(
    ({ id, extraCategoryId }: FetchRelatedTutorialParamsType) => {
      return async function fetchMore(
        this: RelatedTutorialList,
        flow,
      ) {
        if (shouldRejectPagination(this)) {
          return;
        }

        await handleFlow(flow, async () => {
          const res = await Api.Hub.getRelatedTutorials({
            count: this.pageSize,
            start: this.offset,
            id,
            extraCategoryId,
          });

          this.append(castToSnapshot(res.data.videos));
        });
      };
    },
  );
}

export const RelatedTutorialListModel = model(RelatedTutorialList);
